import { useWallet } from '@solana/wallet-adapter-react'

import TokenIcon from '@/components/tokens/TokenIconComponent'
import { EVM_ICON_URL } from '@/constants'
import { EChainType } from '@/constants/chains'
import { useApiTokenContext } from '@/context'
import { WALLET_SOLANA, WALLET_WAGMI } from '@/utils'
import { IWallet, MAPPING_WAGMI_ID } from '@/wallets'

import { useConnect } from 'wagmi'

export const useGetWalletIcon = () => {
  const { connectors } = useConnect()
  const { wallets } = useWallet()
  return (wallet: IWallet | null) => {
    switch (wallet?.key) {
      case WALLET_SOLANA:
        return wallets?.find((e) => e.adapter?.name === wallet?.walletId)?.adapter?.icon ?? ''
      case WALLET_WAGMI:
        const key = MAPPING_WAGMI_ID[wallet?.walletId ?? ''] // override icon
        return (key || connectors.find((e) => e.id === wallet?.walletId)?.icon) ?? ''
      default:
        return wallet?.key ?? ''
    }
  }
}

export const WalletIcon = ({ wallet, className }: { wallet: IWallet | null; className: string }) => {
  const getWalletIcon = useGetWalletIcon()
  return <TokenIcon symbol={getWalletIcon(wallet)} className={className} />
}

export const useGetNetworkIcon = () => {
  const { listNetwork } = useApiTokenContext()
  return (networkId: string | undefined) => {
    const network = listNetwork.find((e) => e.networkId === networkId)
    if (network?.networkType === EChainType.EVM) return EVM_ICON_URL
    return network?.networkLogoUri ?? ''
  }
}
